import { Component, Input } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DemandeStatusService } from 'src/app/core/services/demande-status.service';
import type { PdfViewerAction } from '../../pdf-viewer/pdf-viewer.types';
import { noWhitespaceValidator } from 'src/app/shared/utils/no-whitespace-validator';

@Component({
    selector: 'app-current-validation-table',
    imports: [MatFormFieldModule, ReactiveFormsModule],
    template: `
    @if (demandeStatusService.showValidate(statut!)) {
      <div>
        <table class="table">
          <thead>
            <tr>
              <th>Valideur</th>
              <th>Statut actuel</th>
              <th>Note (obligatoire si c'est un refus de demande)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ valideurNom }} {{ valideurPrenom }}</td>
              <td>
                <span [class]="statusClass">{{ statusText }}</span>
              </td>
              <td>
                @if (viewMode === 'validate' || viewMode === 'refuse' || viewMode === 'review') {
                  <textarea class="form-control" rows="3" placeholder="Saisissez une note " [formControl]="motifRefusControl"></textarea>
                  @if (motifRefusControl.hasError('whitespace') && motifRefusControl.touched) {
                    <div class="text-danger">
                      Ce champ ne peut pas contenir uniquement des espaces.
                    </div>
                  }
                }
                @if (!(viewMode === 'validate' || viewMode === 'refuse' || viewMode === 'review')) {
                  {{ motifRefusControl.value || '-' }}
                }
              </td>
            </tr>
            @if (advice) {
              <tr>
                <td>{{ advice.emetteur.nom }} {{ advice.emetteur.prenom }}</td>
                <td>
                  <span [class]="statusClass" style="background-color: #F5CD30"> Avis demandé à {{ advice.destinataire.nom }} {{ advice.destinataire.prenom }} </span>
                </td>
                <td>
                  {{ advice.note }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    `,
    styles: [
        `
      .table {
        width: 100%;
        margin-bottom: 1rem;
        border-collapse: collapse;
      }
      .table th,
      .table td {
        padding: 8px;
        text-align: left;
        border: 1px solid #ddd;
        vertical-align: middle;
      }
      .table th {
        background-color: #f5f5f5;
      }
      .form-control {
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
      }
    `
    ]
})
export class CurrentValidationTableComponent {
  @Input() valideurNom?: string;
  @Input() valideurPrenom?: string;
  @Input() statusClass?: string;
  @Input() statusText?: string;
  @Input() statut?: string;
  @Input() motifRefusControl: FormControl = new FormControl('');
  @Input() viewMode: PdfViewerAction = 'view';
  @Input() validationStepsLength: number = 0;
  @Input() advice: { 
    emetteur: { nom: string; prenom: string };
    destinataire: { nom: string; prenom: string };
    note: string;
  } | null = null;

  constructor(public demandeStatusService: DemandeStatusService) { }
}
